// Parent/student old AJAX report card (native /exam/report). Globally unique.
export const SP_OLD_REPORT_CARD_LIST = 'SP_OLD_REPORT_CARD_LIST'
export const SP_OLD_REPORT_CARD_VIEW = 'SP_OLD_REPORT_CARD_VIEW'
